module.exports = __webpack_public_path__ + "img/cashFlow-xl.f502206d.svg";